import React, { useState } from 'react';
import { Pie } from 'react-chartjs-2';
import 'chart.js/auto';
import '../sip/Calculators.css'; 

const LifeInsurance = () => {
  const [annualExpense, setAnnualExpense] = useState(300000);
  const [inflationRate, setInflationRate] = useState(6);
  const [coverageYears, setCoverageYears] = useState(20);
  const [existingAssets, setExistingAssets] = useState(500000);
  const [currentLifeCover, setCurrentLifeCover] = useState(300000);
  const [goals, setGoals] = useState([{ id: Date.now(), value: '' }]);
  const [result, setResult] = useState(null);

  const handleAddGoal = () => {
    if (goals.length < 5) {
      setGoals([...goals, { id: Date.now(), value: '' }]);
    }
  };

  const handleGoalChange = (id, value) => {
    setGoals(goals.map(goal => (goal.id === id ? { ...goal, value } : goal)));
  };

  const handleRemoveGoal = (id) => {
    setGoals(goals.filter(goal => goal.id !== id));
  };

  const calculateInsurance = () => {
    const futureExpense = annualExpense * Math.pow(1 + inflationRate / 100, coverageYears);
    const loanRepayment = ((futureExpense - annualExpense) * coverageYears) / 2;
    const provisionForGoals = goals.reduce((acc, goal) => acc + Number(goal.value || 0), 0);
    const householdExpenses = annualExpense;

    setResult({
      loanRepayment: loanRepayment.toFixed(0),
      provisionForGoals,
      householdExpenses
    });
  };

  const pieData = result && {
    labels: ['Loan Repayment', 'Provision for Goals', 'Household Expenses'],
    datasets: [
      {
        data: [
          Number(result.loanRepayment),
          Number(result.provisionForGoals),
          Number(result.householdExpenses),
        ],
        backgroundColor: ['#004aad', '#ffce56', '#76d041'],
      },
    ],
  };

  return (
    <div className="sip-calculator">
      <h2>Life Insurance Planning Calculator</h2>

      <div className="input-group">
        <label>Annual Household Expenses</label>
        <input
          type="range"
          min="0"
          max="10000000"
          step="1000"
          value={annualExpense}
          onChange={(e) => setAnnualExpense(Number(e.target.value))}
        />
        <input
          type="number"
          value={annualExpense}
          onChange={(e) => setAnnualExpense(Number(e.target.value))}
          className="value-box"
        />
      </div>

      <div className="input-group">
        <label>Inflation Rate (%)</label>
        <input
          type="range"
          min="0"
          max="20"
          step="0.1"
          value={inflationRate}
          onChange={(e) => setInflationRate(Number(e.target.value))}
        />
        <input
          type="number"
          value={inflationRate}
          onChange={(e) => setInflationRate(Number(e.target.value))}
          className="value-box"
        />
      </div>

      <div className="input-group">
        <label>Number of Years You Want to Cover</label>
        <input
          type="range"
          min="0"
          max="50"
          value={coverageYears}
          onChange={(e) => setCoverageYears(Number(e.target.value))}
        />
        <input
          type="number"
          value={coverageYears}
          onChange={(e) => setCoverageYears(Number(e.target.value))}
          className="value-box"
        />
      </div>

      <div className="input-group">
        <label>Existing Assets (FD, Mutual Funds, etc.)</label>
        <input
          type="range"
          min="0"
          max="10000000"
          step="1000"
          value={existingAssets}
          onChange={(e) => setExistingAssets(Number(e.target.value))}
        />
        <input
          type="number"
          value={existingAssets}
          onChange={(e) => setExistingAssets(Number(e.target.value))}
          className="value-box"
        />
      </div>

      <div className="input-group">
        <label>Current Life Insurance Cover</label>
        <input
          type="range"
          min="0"
          max="10000000"
          step="1000"
          value={currentLifeCover}
          onChange={(e) => setCurrentLifeCover(Number(e.target.value))}
        />
        <input
          type="number"
          value={currentLifeCover}
          onChange={(e) => setCurrentLifeCover(Number(e.target.value))}
          className="value-box"
        />
      </div>

      <div className="input-group1">
        <label>
          Goals You Want to Protect <br />
          <small>(e.g., child education, marriage, foreign trip, etc.)</small>
        </label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        {goals.length < 5 && (
          <button onClick={handleAddGoal} className="add-goal-btn">
            + Add Goal
          </button>
        )}
        {goals.map((goal, index) => (
          <div key={goal.id} className="goal-input-wrapper">
            <input
              type="number"
              className="value-box"
              placeholder={`Goal ${index + 1}`}
              value={goal.value}
              onChange={(e) => handleGoalChange(goal.id, e.target.value)}
            />
            {goals.length > 1 && (
              <button
                type="button"
                onClick={() => handleRemoveGoal(goal.id)}
                className="remove-goal-btn"
              >
                ✕
              </button>
            )}
          </div>
        ))}
        
      </div>
      <br></br><br></br><br></br>

      <button onClick={calculateInsurance} className="calculate-btn">
        Calculate
      </button>

      {result && (
        <div className="sip-output-section">
          <div className="result-summary">
            <h3>Calculation Summary</h3>
            <p>Loan Repayment: <span>₹ {result.loanRepayment}</span></p>
            <p>Provision for Goals: <span>₹ {result.provisionForGoals}</span></p>
            <p>Household Expenses: <span>₹ {result.householdExpenses}</span></p>
          </div>
          <div className="pie-chart-container">
            <h3>Insurance Requirement Breakdown</h3>
            <Pie data={pieData} />
          </div>
        </div>
      )}
    </div>
  );
};

export default LifeInsurance;
